/** /geo 渠道包（渠道号 6187 / 3796） */
export const GEO_PC_DOWNLOAD =
  "https://static.dhsf.996box.com/box/channel_app/996box503SetupSigned@6187.exe";
export const GEO_ANDROID_DOWNLOAD =
  "https://static.dhsf.996box.com/box/channel_app/1780393202_wDmXEhfyf7.apk";

export const BAIDU_PC_DOWNLOAD =
  "//static.dhsf.996box.com/box/channel_app/996boxSetup@6118.exe";

/** /dxaqy 渠道包（渠道号 6192） */
export const DXAQY_PC_DOWNLOAD =
  "https://static.dhsf.996box.com/box/channel_app/996box507SetupSigned@6192.exe";

export function isGeoRoute(route: any): boolean {
  const query = route && route.query;
  return (
    route.name === "geo" ||
    route.path === "/geo" ||
    (query && query.isCom === "/geo")
  );
}

export function isDxaqyRoute(route: any): boolean {
  const query = route && route.query;
  return (
    route.name === "dxaqy" ||
    route.path === "/dxaqy" ||
    (query && query.isCom === "/dxaqy")
  );
}

/** 爱奇艺 JS 布码：19901=表单提交。下载会跳转，跳转必须放回调里。 */
export function trackDxaqyIqiayiConvert(onJump?: () => void) {
  const tpct = (window as any).iqiyiTpct;
  if (!onJump) {
    if (tpct && typeof tpct.track === "function") tpct.track(19901);
    return;
  }
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    onJump();
  };
  if (tpct && typeof tpct.track === "function") {
    tpct.track(19901, run);
    setTimeout(run, 800);
    return;
  }
  run();
}

export function isBaiduPinzhuanRoute(route: any): boolean {
  const query = route && route.query;
  return (
    route.name === "baidu" ||
    route.path === "/baidu" ||
    (query && query.isCom === "/baidu")
  );
}

export function getPinzhuanPcDownloadUrl(route: any): string {
  if (isGeoRoute(route)) return GEO_PC_DOWNLOAD;
  if (isDxaqyRoute(route)) return DXAQY_PC_DOWNLOAD;
  return BAIDU_PC_DOWNLOAD;
}

export function getPinzhuanAndroidDownloadUrl(route: any): string {
  if (isGeoRoute(route)) return GEO_ANDROID_DOWNLOAD;
  return "https://static.dhsf.996box.com/box/channel_app/1673505426000_fEh4A.apk";
}
